import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import DatePicker from "react-datepicker";
import { useFetchData } from "../../hooks/useFetchData";
import { formatNumber } from "../../utils/data/essential";
import "chartjs-plugin-datalabels";
import PieChart from "../../Component/dashboard-charts/PieChart";
import Skeleton from "react-loading-skeleton";
import QuarteryChart from "../../Component/dashboard-charts/QuarterlyChart";
import { Button } from "react-bootstrap";
import { Row, Col } from "react-bootstrap";
import Locations from "../../Component/Locations";
import useAxios from "../../hooks/useAxios";
const quarters = ["Quarter 1", "Quarter 2", "Quarter 3", "Quarter 4"];
const getCurrentQuarter = () => {
  const month = new Date().getMonth() + 1; // Adding 1 because getMonth() returns zero-based index
  return Math.ceil(month / 3); // Calculate quarter based on current month
};
const TopDashboard = () => {
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const location = JSON.parse(localStorage.getItem("locations"));
  const [locationId, setLocationId] = useState(
    location[location.length - 1].id
  );
  const [locationName, setLocationName] = useState(
    location[location.length - 1].name
  );
  let user = null;
  const datafromChildComponent = (data) => {
    setLocationId(data.locationId);
    setLocationName(data.locationName);
  };

  try {
    const storedUser = localStorage.getItem("user");
    user = storedUser ? JSON.parse(storedUser) : null;
  } catch (error) {
    console.error("Error parsing user data:", error);
  }
  let date = new Date(selectedMonth);
  let shortMonth = date.toLocaleDateString("default", { month: "short" });
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  const url = `reports/monthly?location=${locationId}&month=${month}&year=${year}`;
  const { data: dashboardData } = useFetchData(
    ["monthly-report", month, year, locationId],
    url,
    true
  );
  let totalTargets = 0;
  let totalCollections = 0;
  if (dashboardData) {
    dashboardData.forEach((element) => {
      totalCollections += element.currentCollectedAmount;
      totalTargets += element.currentTargetAmount;
    });
  }
  const locations = dashboardData?.map((data) => data.location.name);
  const targetAmounts = dashboardData?.map((data) => data.currentTargetAmount);
  const collectedAmounts = dashboardData?.map(
    (data) => data.currentCollectedAmount
  );
  const data = {
    labels: locations,
    datasets: [
      {
        label: "Target Amount",
        backgroundColor: "#124db1",
        borderColor: "#124db1",
        borderWidth: 1,
        data: targetAmounts,
      },
      {
        label: "Collected Amount",
        backgroundColor: "#35D49B",
        borderColor: "#35D49B",
        borderWidth: 1,
        data: collectedAmounts,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    responsive: true,
    scales: {
      x: { stacked: false },
      y: { stacked: false },
    },
    plugins: {
      datalabels: {
        display: true,
        anchor: "end",
        align: "bottom",
        offset: 4,
        formatter: (value, context) => {
          if (context.dataset.label === "Target Amount") {
            return formatNumber(value);
          } else if (context.dataset.label === "Collected Amount") {
            return formatNumber(value);
          }

          return formatNumber(value);
        },
        font: {
          size: (context) => {
            const barWidth =
              context.chart.scales.x.getPixelForValue(context.dataIndex + 1) -
              context.chart.scales.x.getPixelForValue(context.dataIndex);
            console.log("bar width:", barWidth);
            const fontSize = Math.min(Math.max(barWidth / 5, 10), 14);
            console.log("calculated font size:", fontSize);
            return fontSize;
          },
        },
        color: "#fff",
      },
    },
  };
  const currentQuarter = getCurrentQuarter();
  return (
    <>
      <div className='d-flex justify-content-end m-2' style={{ gap: 10 }}>
        <DatePicker
          selected={selectedMonth}
          onChange={(date) => setSelectedMonth(date)}
          dateFormat='MM/yyyy'
          showMonthYearPicker
          className='form-control input-select report-date-picker'
          title='Select Month and year'
        />
      </div>
      <Locations sendDataToParent={datafromChildComponent} />
      {dashboardData && dashboardData.length > 1 && (
        <div className='d-flex justify-content-center'>
          <div className='card mt-2 dashboard-card-width'>
            <div className='d-flex justify-content-center'>
              <h6 style={{ fontSize: "20px" }}>{locationName}</h6>
            </div>
            <div className='d-flex justify-content-between'>
              <div>
                <h5 style={{ fontSize: "17px" }}>Target</h5>
                <h6 style={{ fontSize: "14px" }}>
                  {formatNumber(totalTargets)}
                </h6>
              </div>
              <div>
                <h5 style={{ fontSize: "17px" }}>Collection</h5>
                <h6 style={{ fontSize: "14px" }}>
                  {formatNumber(totalCollections)}
                </h6>
              </div>
              <div>
                <h5 style={{ fontSize: "17px" }}>Percentage</h5>
                <h6 style={{ fontSize: "14px" }}>
                  {((totalCollections / totalTargets) * 100).toFixed(2)}%
                </h6>
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        className='d-flex justify-content-between ml-2 mr-2'
        style={{ gap: 10 }}
      >
        {dashboardData && (
          <Row style={{ width: "100%" }}>
            {dashboardData.map((data) => (
              <Col
                xs={12}
                sm={6}
                md={4}
                xlg={dashboardData.length < 5 ? 4 : 2}
                key={data.id}
                className='mb-3 mt-3'
              >
                <div className='card'>
                  <div className='d-flex justify-content-center'>
                    <h6 style={{ fontSize: "20px" }}>{data.location.name}</h6>
                  </div>
                  <div className='d-flex justify-content-between'>
                    <div>
                      <h5 style={{ fontSize: "17px" }}>Target</h5>
                      <h6 style={{ fontSize: "14px" }}>
                        {formatNumber(data.currentTargetAmount)}
                      </h6>
                    </div>
                    <div>
                      <h5 style={{ fontSize: "17px" }}>Collection</h5>
                      <h6 style={{ fontSize: "14px" }}>
                        {formatNumber(data.currentCollectedAmount)}
                      </h6>
                    </div>
                    <div>
                      <h5 style={{ fontSize: "17px" }}>Percentage</h5>
                      <h6 style={{ fontSize: "14px" }}>
                        {(
                          (data.currentCollectedAmount /
                            data.currentTargetAmount) *
                          100
                        ).toFixed(2)}
                        %
                      </h6>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        )}
      </div>
      {dashboardData && locationId === 1 && (
        <>
          {locationId === 1 || dashboardData?.length < 10 ? (
            <div className='d-flex flex-wrap p-3' style={{ gap: 10 }}>
              <div className='card bar-chart' style={{ height: 250 }}>
                {dashboardData ? (
                  <Bar data={data} options={options} height={200} />
                ) : (
                  <Skeleton />
                )}
              </div>
              <div className='card pie-chart' style={{ height: 250 }}>
                {dashboardData ? (
                  <div>
                    <PieChart data={dashboardData} options={options} />
                  </div>
                ) : (
                  <Skeleton />
                )}
              </div>
            </div>
          ) : (
            <>
              <div className='card m-3' style={{ height: "40%" }}>
                {dashboardData ? (
                  <div>
                    <Bar data={data} options={options} />
                  </div>
                ) : (
                  <Skeleton />
                )}
              </div>
              <div className='card m-3'>
                <div className='d-flex justify-content-center'>
                  {dashboardData ? (
                    <PieChart data={dashboardData} />
                  ) : (
                    <Skeleton />
                  )}
                </div>
              </div>
            </>
          )}
        </>
      )}
      {/* <div className='d-flex justify-content-center flex-wrap'>
        {quarters.map((quarter, index) => (
          <Button
            key={quarter}
            className='custom-btn-color mr-2'
            disabled={index + 1 > currentQuarter}
          >
            {quarter}
          </Button>
        ))}
        ;
      </div>
      <div className='d-flex flex-wrap p-3' style={{ gap: 10 }}>
        <div className='card' style={{ width: "48%" }}>
          <QuarteryChart />
        </div>
        <div className='card' style={{ width: "48%" }}>
          <QuarteryChart />
        </div>
      </div> */}
    </>
  );
};

export default TopDashboard;
